import React, { useEffect } from 'react';
import { mainSuite } from '../../services/ServiceFactory';
import { PlotsDispatchContext, PlotsStateContext } from './PlotsContext';
import { UserPlotsDispatchContext, UserPlotsStateContext } from './UserPlotsContext';

export function PlotsSetup(): JSX.Element {
  const plotsService = mainSuite.plotsService;
  const plotsState = React.useContext(PlotsStateContext);
  const plotsDispatch = React.useContext(PlotsDispatchContext);
  const userPlotsState = React.useContext(UserPlotsStateContext);
  const userPlotsDispatch = React.useContext(UserPlotsDispatchContext);

  useEffect(() => {
    plotsService.setPlotsState(plotsState);
  }, [plotsState]);

  useEffect(() => {
    plotsService.setPlotsDispatch(plotsDispatch);
  }, [plotsDispatch]);

  useEffect(() => {
    plotsService.setUserPlotsState(userPlotsState);
  }, [userPlotsState]);

  useEffect(() => {
    plotsService.setUserPlotsDispatch(userPlotsDispatch);
  }, [userPlotsDispatch]);

  return null;
}
